import { Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-card">
    {/* Mitra Driver band */}
    <div className="border-b border-white/10 bg-background">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-4 py-8 sm:px-6 md:flex-row md:items-center">
        <div>
          <h3 className="font-display text-lg font-bold tracking-tight sm:text-xl">Punya armada travel? Gabung jadi Mitra Driver.</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Tampilkan jadwal Anda di Digital Terminal dan dapatkan penumpang dari seluruh Indonesia.
          </p>
        </div>
        <div className="flex shrink-0 gap-2">
          <Link to="/daftar" data-testid="footer-daftar-driver" className="rounded-md bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground transition-transform hover:-translate-y-0.5">
            Daftar Mitra Driver
          </Link>
          <Link to="/masuk" data-testid="footer-driver-login" className="rounded-md border border-border px-5 py-2.5 text-sm font-semibold transition-colors hover:border-primary">
            Masuk Driver
          </Link>
        </div>
      </div>
    </div>
    <div className="mx-auto grid max-w-7xl gap-8 px-4 py-14 sm:px-6 md:grid-cols-4">
      <div>
        <div className="mb-3">
          <img src="/travele-logo.png" alt="Travele — Travel, Charter Mobil, Paket Kilat" className="h-11 w-auto" />
        </div>
        <p className="text-sm leading-relaxed text-muted-foreground">
          Digital Terminal Travel Door to Door dan Charter Drop Off Indonesia. Marketplace yang mempertemukan driver dengan penumpang antarkota.
        </p>
      </div>
      <div>
        <h4 className="mb-3 font-semibold">Layanan</h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/pesan-travel" className="hover:text-primary" data-testid="footer-pesan-travel">Travel Door to Door</Link></li>
          <li><Link to="/pesan-charter" className="hover:text-primary" data-testid="footer-pesan-charter">Charter Mobil</Link></li>
          <li><Link to="/pesan-paket" className="hover:text-primary" data-testid="footer-pesan-paket">Kirim Paket Kilat</Link></li>
          <li>Antar-jemput Bandara</li>
          <li><Link to="/ulasan" className="hover:text-primary">Beri Ulasan Perjalanan</Link></li>
          <li><Link to="/lacak-order" className="hover:text-primary">Lacak Order</Link></li>
          <li><Link to="/pengaduan" className="hover:text-primary">Pengaduan & Sengketa</Link></li>
          <li><Link to="/blog" className="hover:text-primary">Blog & Artikel</Link></li>
          <li><Link to="/tentang-kami" className="hover:text-primary">Tentang Kami</Link></li>
          <li><Link to="/faq" className="hover:text-primary">FAQ</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="mb-3 font-semibold">Rute Populer</h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/travel-semarang-jakarta" className="hover:text-primary">Travel Semarang Jakarta</Link></li>
          <li><Link to="/travel-semarang-bandung" className="hover:text-primary">Travel Semarang Bandung</Link></li>
          <li><Link to="/travel-kudus-jakarta" className="hover:text-primary">Travel Kudus Jakarta</Link></li>
          <li><Link to="/travel-jepara-bekasi" className="hover:text-primary">Travel Jepara Bekasi</Link></li>
          <li><Link to="/rute" className="hover:text-primary" data-testid="footer-all-routes">Semua Rute &amp; Kota</Link></li>
          <li><Link to="/sitemap" className="hover:text-primary" data-testid="footer-sitemap">Peta Situs (Sitemap)</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="mb-3 font-semibold">Kontak Admin</h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-primary" /> 0811-2828-852</li>
          <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-primary" /> Seluruh Indonesia</li>
        </ul>
        <p className="mt-4 text-xs text-muted-foreground">Semua pemesanan diarahkan ke WhatsApp Admin resmi.</p>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-muted-foreground">
      <Link to="/syarat-ketentuan" data-testid="footer-terms" className="hover:text-primary">Syarat & Ketentuan (Terms & Conditions)</Link>
      <span className="mx-2">·</span>
      <Link to="/kebijakan-privasi" data-testid="footer-privacy" className="hover:text-primary">Kebijakan Privasi</Link>
      <span className="mx-2">·</span>
      © {new Date().getFullYear()} Travele — Digital Terminal Indonesia. Marketplace, bukan operator travel.
    </div>
  </footer>
);
